import { render, staticRenderFns } from "./ListAnnotations.vue?vue&type=template&id=7017d59b&scoped=true&"
import script from "./ListAnnotations.vue?vue&type=script&lang=js&"
export * from "./ListAnnotations.vue?vue&type=script&lang=js&"
import style0 from "./ListAnnotations.vue?vue&type=style&index=0&id=7017d59b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7017d59b",
  null
  
)

export default component.exports